module.exports = __webpack_public_path__ + "media/images/flagship_fragrance_machines/2-c3f4c69064cc9bbfc902e466d4b97eab.jpg";